import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { AuthWrapper } from './context/authContext';

ReactDOM.render(
  <React.StrictMode>
    <AuthWrapper logoutRoute="/">
      <App />
    </AuthWrapper>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
